import React, {useState, useCallback} from 'react';

interface SwitchProps {
  checked: boolean;
  onChange: (value: boolean) => void;
}

const Switch: React.FC<SwitchProps> = ({checked, onChange}) => {
  const [isChecked, setIsChecked] = useState<boolean>(checked);

  const handleChange = useCallback(() => {
    const newValue = !isChecked;
    setIsChecked(newValue);
    onChange(newValue);
  }, [isChecked, onChange]);

  return (
    <div
      className={`relative h-[30px] w-[55px] rounded-full transition-colors duration-300 ${
        isChecked
          ? 'bg-acai-900 after:translate-x-[25px] after:bg-white'
          : 'bg-clay-100 after:translate-x-0 after:bg-white'
      }`}
      onClick={handleChange}
    >
      <span
        className={`absolute left-[4px] top-[4px] h-[22px] w-[22px] transform rounded-full bg-white shadow-md transition-transform duration-300 ${
          isChecked ? 'translate-x-[25px]' : 'translate-x-0'
        }`}
      ></span>
    </div>
  );
};

export default Switch;
